var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "boss-button-center pega-preview-jump-button hide-for-print",
      attrs: { "data-test": "spPreview" },
      on: { click: _vm.openSpPreview },
    },
    [
      _c("img", {
        staticClass: "pega-icon-phone",
        attrs: { src: require("@/assets/images/smartphone.png") },
      }),
      _vm._v("\n  スマホ版プレビューはこちら\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }